<template>

    <v-modal :title="$t('labels.delete_review')">
        <template #body>
            <v-alert :message="error" />
            <p>{{ $t('alerts.review_delete') }}</p>
        </template>
        <template #footer>
            <v-button size="sm" theme="white" @click.native="cancel">{{ $t('labels.cancel') }}</v-button>
            <v-button size="sm" theme="danger" :loading="loading" @click.native="deleteReview">{{ $t('labels.delete') }}</v-button>
        </template>
    </v-modal>

</template>

<script>

import ReviewApi from '@api/ReviewApi';

import Modal from '@cmp/Modal';

export default {

    components: {
        'v-modal': Modal,
    },

    props: {
        reviewId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    methods: {

        deleteReview() {
            this.loading = true;
            ReviewApi.deleteReview(this.reviewId)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('messages.deleted'));
                    this.$store.commit('setModal', null);
                    this.$emit('saved');
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('setModal', null);
        },

    },

}

</script>
